import TenantLeasesTable from './TenantLeasesTable'

export default TenantLeasesTable
